import React, { forwardRef } from "react";
import { Link } from "react-router-dom";
import { COMPANY } from "../mock";
import { trackPhoneClick } from "../lib/analytics";

// Site-wide sticky emergency bar. Rendered by <Header /> so every page gets it.
const EmergencyBanner = forwardRef((_, ref) => (
  <div
    ref={ref}
    data-testid="emergency-banner"
    className="sticky top-0 z-[60] text-white border-b-2 border-orange-500"
    style={{ backgroundColor: "#1a1a1a", color: "#ffffff" }}
  >
    <div className="max-w-7xl mx-auto px-3 sm:px-4 py-2 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-5">
      <p className="m-0 text-[13px] sm:text-[15px] font-bold text-center leading-tight" style={{ color: "#ffffff" }}>
        <span aria-hidden="true">🚨</span> Emergency Appliance Breakdown? Same-Day Service Available!
      </p>
      <div className="flex items-center gap-2">
        <a
          href={`tel:${COMPANY.phoneRaw}`}
          onClick={() => trackPhoneClick("emergency-banner")}
          data-testid="emergency-banner-call"
          className="inline-flex items-center bg-white hover:bg-orange-100 px-4 py-1.5 rounded font-bold text-[13px] transition-colors whitespace-nowrap"
          style={{ color: "#1a1a1a" }}
        >
          <span aria-hidden="true">📞</span>&nbsp;Tap to Call Now
        </a>
        <Link
          to="/contact#book"
          data-testid="emergency-banner-book"
          className="inline-flex items-center border-2 border-white hover:bg-white/15 px-4 py-1.5 rounded font-bold text-[13px] transition-colors whitespace-nowrap"
          style={{ color: "#ffffff" }}
        >
          <span aria-hidden="true">📅</span>&nbsp;Book a Repair Online
        </Link>
      </div>
    </div>
  </div>
));

EmergencyBanner.displayName = "EmergencyBanner";

export default EmergencyBanner;
